import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { R1DashboardProvider } from "@/features/R1Dashboard/context/R1DashboardProvider";
import R1AnalyticsView from "@/features/R1Dashboard/views/AnalyticsView";

export default function R1Analytics() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Analytics");
  }, []);

  return (
    <R1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <R1AnalyticsView />
      </main>
    </R1DashboardProvider>
  );
}
